import { Component, HostBinding, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'suka-card-header',
  template: `
    <h5 *ngIf="skeleton" class="skeleton__text skeleton__heading"></h5>
    <h5 *ngIf="!skeleton"><ng-content></ng-content></h5>
    <button
      *ngIf="!skeleton && showAction"
      sukaButton="plain"
      (click)="onClick($event)"
    >
      {{actionLabel}}
    </button>
  `,
})

// tslint:disable-next-line: component-class-suffix
export class CardHeader implements OnInit {
  showAction = false;

  @HostBinding('class.card-header') cardHeaderClass = true;

  @Input() skeleton = false;
  @Input() actionLabel: string;
  @Output() action = new EventEmitter();

  ngOnInit() {
    this.showAction = this.action.observers.length > 0;
  }

  onClick($event) {
    this.action.emit($event);
  }
}
